module.exports = __webpack_public_path__ + "img/agent_ferroviere.f0876ffa.jpg";